import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export const money = (n) => `$${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const when = (v) => (v ? new Date(v).toLocaleString() : '—');

// Small fetch helper shared by the Payments screens
export const usePayApi = (token, path) => {
  const [data, setData] = useState(null);
  const headers = { Authorization: `Bearer ${token}` };
  const load = useCallback(() => {
    if (!path) return;
    axios.get(`${API}/api/admin/payments${path}`, { headers }).then((r) => setData(r.data)).catch((e) => toast.error(e.response?.data?.detail || 'Could not load'));
  }, [token, path]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [load]);
  const send = async (method, p, body, ok, onError) => {
    try {
      const r = await axios({ method, url: `${API}/api/admin/payments${p}`, data: body, headers });
      if (ok) toast.success(ok);
      load();
      return r.data;
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : d?.message || 'Action failed');
      if (onError) onError(d);
      return null;
    }
  };
  return { data, load, send };
};

export const ModeBadge = ({ mode, testId = 'payments-mode-badge', size = 'sm' }) => {
  const live = mode === 'live';
  const cls = size === 'lg' ? 'px-3 py-1 text-sm' : 'px-2 py-0.5 text-[11px]';
  return (
    <span className={`${cls} rounded font-bold tracking-wider ${live ? 'bg-emerald-600 text-white' : 'bg-amber-400 text-amber-950'}`} data-testid={testId}>
      {live ? 'LIVE PAYMENTS' : mode === 'test' ? 'TEST MODE' : 'NOT CONNECTED'}
    </span>
  );
};

export const Pill = ({ on, onText = 'Enabled', offText = 'Disabled', testId }) => (
  <span className={`px-2 py-0.5 rounded-full text-[11px] font-medium border ${on ? 'bg-emerald-50 text-emerald-700 border-emerald-200' : 'bg-neutral-100 text-neutral-500 border-neutral-200'}`} data-testid={testId}>{on ? onText : offText}</span>
);

const TX_STATUS = {
  paid: 'bg-emerald-50 text-emerald-700', pending: 'bg-amber-50 text-amber-800', failed: 'bg-red-50 text-red-700', expired: 'bg-neutral-100 text-neutral-500',
  cancelled: 'bg-neutral-100 text-neutral-500', refunded: 'bg-violet-50 text-violet-700', partially_refunded: 'bg-violet-50 text-violet-700',
};
export const TxStatus = ({ s, testId }) => <span className={`px-2 py-0.5 rounded-full text-[11px] font-medium ${TX_STATUS[s] || 'bg-neutral-100'}`} data-testid={testId}>{(s || '').replace('_', ' ')}</span>;
